import axios, { AxiosError } from 'axios';
import {
  CdqExternalLead,
  ExternalLeadListParams,
  LoanExternalLead,
  MortgageExternalLead,
  PaginatedResponse,
} from '@tassomutuo-backoffice/types';
import { axiosApiInstancePrivate } from '../index';

const BASE_PATH = '/v1/backoffice/external-leads';

function handleAxiosError(err: unknown): never {
  const error = err as Error | AxiosError;
  if (axios.isAxiosError(error)) {
    throw error?.response?.data ?? error;
  }
  throw err;
}

export const listMortgageExternalLeads = async (
  params: ExternalLeadListParams
): Promise<PaginatedResponse<MortgageExternalLead>> => {
  try {
    const { data } = await axiosApiInstancePrivate.get<
      PaginatedResponse<MortgageExternalLead>
    >(`${BASE_PATH}/mortgage`, { params });
    return data;
  } catch (err) {
    handleAxiosError(err);
  }
};

export const listLoanExternalLeads = async (
  params: ExternalLeadListParams
): Promise<PaginatedResponse<LoanExternalLead>> => {
  try {
    const { data } = await axiosApiInstancePrivate.get<
      PaginatedResponse<LoanExternalLead>
    >(`${BASE_PATH}/loan`, { params });
    return data;
  } catch (err) {
    handleAxiosError(err);
  }
};

export const listCdqExternalLeads = async (
  params: ExternalLeadListParams
): Promise<PaginatedResponse<CdqExternalLead>> => {
  try {
    const { data } = await axiosApiInstancePrivate.get<
      PaginatedResponse<CdqExternalLead>
    >(`${BASE_PATH}/cdq`, { params });
    return data;
  } catch (err) {
    handleAxiosError(err);
  }
};

export const getMortgageExternalLead = async (
  id: string
): Promise<MortgageExternalLead> => {
  try {
    const { data } = await axiosApiInstancePrivate.get<MortgageExternalLead>(
      `${BASE_PATH}/mortgage/${id}`
    );
    return data;
  } catch (err) {
    handleAxiosError(err);
  }
};

export const getLoanExternalLead = async (
  id: string
): Promise<LoanExternalLead> => {
  try {
    const { data } = await axiosApiInstancePrivate.get<LoanExternalLead>(
      `${BASE_PATH}/loan/${id}`
    );
    return data;
  } catch (err) {
    handleAxiosError(err);
  }
};

export const getCdqExternalLead = async (
  id: string
): Promise<CdqExternalLead> => {
  try {
    const { data } = await axiosApiInstancePrivate.get<CdqExternalLead>(
      `${BASE_PATH}/cdq/${id}`
    );
    return data;
  } catch (err) {
    handleAxiosError(err);
  }
};
